import * as t from 'io-ts';
import { SkeletalDataProvider } from '../../../enums';
import { enumCodec } from '../../../validation/validator';

export const getSignedUrlRequestSchema = t.type({
  file_name: t.string,
  file_size: t.number,
  match_id: t.string,
  provider: enumCodec(SkeletalDataProvider)
});

export const getSignedUrlResponseSchema = t.type({
  code: t.string,
  data: t.type({
    upload_url: t.string,
    expires_at: t.string
  })
});

export type getSignedUrlRequest = t.TypeOf<typeof getSignedUrlRequestSchema>;
export type getSignedUrlResponse = t.TypeOf<typeof getSignedUrlResponseSchema>;

export const getMatchFragmentsRequestSchema = t.type({
  match_id: t.string
});

export const getMatchFragmentsResponseSchema = t.type({
  code: t.string,
  data: t.type({
    duration: t.number,
    fragmentDuration: t.number,
    ladders: t.array(t.type({
      hz: t.number
    })),
    fragments: t.array(t.type({
      t: t.number,
      sidecarUrl: t.string,
      payloadUrl: t.string
    })),
    tokenInfo: t.type({
      type: t.string,
      expiry: t.number
    })
  })
});

export type getMatchFragmentsRequest = t.TypeOf<typeof getMatchFragmentsRequestSchema>;
export type getMatchFragmentsResponse = t.TypeOf<typeof getMatchFragmentsResponseSchema>;

export const getAccountMatchesRequestSchema = t.type({
  account_id: t.number
});

export const getAccountMatchesResponseSchema = t.type({
  code: t.string,
  data: t.array(t.type({
    id: t.string,
    name: t.string,
    match_date: t.string,
    home_team_id: t.number,
    away_team_id: t.number,
    home_team_score: t.number,
    away_team_score: t.number,
    competition_name: t.string
  }))
});

export type getAccountMatchesRequest = t.TypeOf<typeof getAccountMatchesRequestSchema>;
export type getAccountMatchesResponse = t.TypeOf<typeof getAccountMatchesResponseSchema>;

export const StreamingSkeletalApis = {
  Streaming: {
    Skeletal: {
      GetUploadUrl: {
        Name: 'streaming-skeletal-getSignedUrl',
        Request: getSignedUrlRequestSchema,
        Response: getSignedUrlResponseSchema
      },
      GetMatchFragments: {
        Name: 'streaming-skeletal-getMatchFragments',
        Request: getMatchFragmentsRequestSchema,
        Response: getMatchFragmentsResponseSchema
      },
      GetAccountMatches: {
        Name: 'streaming-skeletal-getAccountMatches',
        Request: getAccountMatchesRequestSchema,
        Response: getAccountMatchesResponseSchema
      }
    }
  }
};
